import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/help_center'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  fetchDemosRequestRunning: false
})

export default handleActions(
  {
    [Actions.fetchDemosStart]: state => state.set('fetchDemosRequestRunning', true),
    [combineActions(
      Actions.fetchDemosSuccess,
      Actions.fetchDemosError
    )]: state => state.set('fetchDemosRequestRunning', false),
    [AppActions.resetState]: () => initialState
  },
  initialState
)
